import AwsSlice from './aws.slice';

export const { actions: aws_actions } = AwsSlice;

export default AwsSlice.reducer;
